module.exports = __webpack_public_path__ + "media/images/map-marker-98966e7b35004b50a7bbf8085ce2c957.svg";